import initialState from './initialState';

export default function groupsReducer(state = initialState.data, action) {
    switch (action.type) {
        default: {
            return state;
        }
    }
}
